import React, { useState, useEffect } from "react";

const LoadingScreen = ({ isLoading }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 500); // Slightly longer fade-out for smooth transition
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-md transition-opacity duration-500 ${
        isLoading ? "opacity-100 scale-100" : "opacity-0 scale-95"
      }`}
    >
      <div className="flex flex-col items-center">
        <img
          src="/web-logo.png"
          alt="Logo"
          className="h-24 w-24 animate-pulse drop-shadow-lg"
        />
        <p className="text-gray-300 text-sm mt-4 tracking-wide animate-fadeIn">
          Loading...
        </p>
        <div className="mt-6 h-12 w-12 animate-spin rounded-full border-4 border-transparent border-t-blue-500 border-r-blue-500"></div>
      </div>
    </div>
  );
};

export default LoadingScreen;
